import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";
import { Header } from "./shared/Header";
import { Title } from "./shared/Title";
import { Footer } from "./shared/Footer";
import { Content } from "./shared/Content";
import { useContext } from "../../context";

export const Preview = () => {
  const { layout } = useContext();

  const rootClasses = cx(styles.root, {
    [styles.fullView]: layout.preview.isFullView,
  });

  return (
    <div className={rootClasses}>
      <Header />
      <Title />
      <Content />
      <Footer />
    </div>
  );
};
